export class TabsUtil
{
    public static SLOT_SHEET_ID_PREFIX = 'slotSheetButton_';

    public static getMenuButtonId(slotSheetId:string):string
    {
        return `${TabsUtil.SLOT_SHEET_ID_PREFIX}${slotSheetId}`;
    }
}
